import React, { ReactElement } from 'react';
import './index.less';
import { message, Modal, Popconfirm } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const Delete: React.FC<{
  children?: ReactElement;
  type?: string;
  icon?: ReactElement;
  onConfirm?: any;
  title?: ReactElement | string;
  content?: ReactElement | string;
  onCancel?: any;
  okText?: string;
  cancelText?: string;
  okButtonProps?: any;
  cancelButtonProps?: any;
}> = function ({
  children,
  type = 'popConfirm',
  title = '确定删除吗？',
  content = '删除之后不可恢复',
  onConfirm = () => {
    message.error('请传入确认按钮回调函数！');
  },
  onCancel = () => {},
  okText = '确定',
  cancelText = '取消',
  okButtonProps = {},
  cancelButtonProps = {},
}) {
  function showDelConfirm(e: any) {
    e.stopPropagation();
    Modal.confirm({
      title: title,
      cancelButtonProps: {
        shape: 'round',
        ...cancelButtonProps,
      },
      okButtonProps: {
        shape: 'round',
        ...okButtonProps,
      },
      icon: <ExclamationCircleOutlined />,
      content: content,
      okText: okText,
      cancelText: cancelText,
      onCancel,
      onOk: onConfirm,
      className: 'TY_delete_modal_wrap',
    });
  }

  function DeletePopConfirm() {
    return (
      <Popconfirm
        title={title}
        okText={okText}
        cancelText={cancelText}
        onConfirm={onConfirm}
        cancelButtonProps={{ shape: 'round', ...cancelButtonProps }}
        okButtonProps={{ shape: 'round', ...okButtonProps }}
        onCancel={onCancel}
      >
        {children}
      </Popconfirm>
    );
  }

  function DeleteModal() {
    return <span onClick={(e) => showDelConfirm(e)}>{children}</span>;
  }
  return type === 'popConfirm' ? DeletePopConfirm() : DeleteModal();
};

export default Delete;
